import { NodeChildAssociation } from '@alfresco/js-api';

export interface WkSiteContainerModel {
  name: string;
  id: string;
  title?: string;
  entry?: NodeChildAssociation;
}
